import { Fragment, useMemo, useState } from "react";

import { formatPoints } from "@vericus/cadmus-common";
import { SelectButton, Text } from "@vericus/cadmus-ui";

import * as styles from "./question-sets-preview.css";
import * as sheetStyles from "./sheet-preview.css";
import { TaskBlockPreview } from "./task-block-preview";
import { PreviewSet } from "./types";

export interface Props {
  sets: PreviewSet[];
  groupLabel: string;
  groupPoints: number | null;
  correctResponseMarking: boolean;
}

export function QuestionSetsPreview(props: Props) {
  const { sets, groupLabel, groupPoints, correctResponseMarking } = props;
  const [activeSet, setActiveSet] = useState(sets[0]?.id);
  const blocks = useMemo(() => {
    const set = sets.find(({ id }) => id === activeSet);
    return set?.questions ?? [];
  }, [sets, activeSet]);

  return (
    <>
      <div className={styles.root}>
        <div className={styles.header}>
          <Text kind="headingFour" as="span">
            {groupLabel}
          </Text>
          <span className={styles.rightHeader}>
            <Text kind="systemMd" color="navy500">
              {groupPoints ? formatPoints(groupPoints) : "0 points"}
            </Text>
          </span>
        </div>
        <div>
          <div className={styles.tabList}>
            {sets?.map(({ id, longLabel }) => (
              <SelectButton
                key={id}
                style={{ minWidth: "min-content" }}
                selected={id === activeSet}
                withDownCaret={false}
                onClick={() => setActiveSet(id)}
              >
                {longLabel}
              </SelectButton>
            ))}
          </div>
        </div>
      </div>
      {blocks &&
        blocks.map((block) => {
          if (block.question) {
            return (
              <Fragment key={block.id}>
                {!block.isChildQuestion && (
                  <div className={sheetStyles.section}>
                    <div className={sheetStyles.divider} />
                  </div>
                )}
                <TaskBlockPreview
                  question={block.question}
                  questionTitle={block.longLabel}
                  points={block.points}
                  isChildQuestion={block.isChildQuestion}
                  correctResponseMarking={correctResponseMarking}
                  socraticQuestionerEnabled={false}
                />
              </Fragment>
            );
          }
          return null;
        })}
    </>
  );
}
